import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'
import { cn } from '@/lib/utils'

/**
 * A labelled on/off setting, its description read with the switch. Dimmed as
 * a whole when disabled: the label comes before the switch, so its own
 * `peer-disabled` styles can't see it.
 */
export function SwitchRow({
  id,
  label,
  description,
  checked,
  disabled,
  className,
  checkedClassName,
  switchClassName,
  switchSize,
  onCheckedChange,
}: {
  id: string
  label: string
  description: string
  checked: boolean
  disabled: boolean
  className?: string
  /** Added to the row while it is on, e.g. a tint. */
  checkedClassName?: string
  switchClassName?: string
  switchSize?: 'sm' | 'default'
  onCheckedChange: (checked: boolean) => void
}) {
  return (
    <div
      className={cn(
        'flex items-start gap-3 py-2.5',
        className,
        checked && checkedClassName,
        disabled && 'cursor-not-allowed opacity-50'
      )}>
      <div className="min-w-0 flex-1">
        <Label htmlFor={id} className="text-sm">
          {label}
        </Label>
        <p id={`${id}-description`} className="text-xs text-muted-foreground">
          {description}
        </p>
      </div>
      <Switch
        id={id}
        size={switchSize}
        className={switchClassName}
        checked={checked}
        disabled={disabled}
        aria-describedby={`${id}-description`}
        onCheckedChange={onCheckedChange}
      />
    </div>
  )
}
